import React, { useState, useContext, useMemo, useEffect } from "react";
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalCicloAdd } from "../../styled-components/StyledModalCicloAdd.style";
import "react-datepicker/dist/react-datepicker.css";
import api from '../../services/api';
import { StyledTablePmePrograma } from "../../styled-components/StyledTablePmePrograma.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { StldRow } from "../../styled-components/StldRow.style";
import { StldColumn } from "../../styled-components/StldColumn.style";
import Swal from "sweetalert2";

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const ModalProfissionalPme = ({ isOpen, onAfterOpen, onRequestClose, idProgramaParam }) => {
    const [listaUsuariosData, setListaUsuariosData] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const getProfissionaisNaoAssociados = async(idPrograma) => {
        const response = await api.get(`PmeProfissionalPME/nao-associados/programa/${idPrograma}`, config);

        setListaUsuariosData(response.data);
    };

    const handleCheckboxUsuariosChange = (userId) => {
        setSelectedUsers((prevSelected) => {
            if (prevSelected.includes(userId)) {
                return prevSelected.filter((idUsuario) => idUsuario !== userId);
            } else {
                return [...prevSelected, userId];
            }
        });
    };

    const handleSelectAll = (checked) => {
        if (checked) {
            setSelectedUsers(listaUsuariosData.data.map((user) => user.idUsuario));
        } else {
            setSelectedUsers([]);
        }
    };

    useEffect(() => {
        const asyncFn = async () => {            
            if (idProgramaParam > 0) {
                await getProfissionaisNaoAssociados(idProgramaParam);
            }
        }
        asyncFn();

    }, [idProgramaParam]);

    const addProfissionaisAoPrograma = async () => {
        
        if (!selectedUsers.length) {
            Swal.fire({
                title: "Atenção",
                text: "Selecione ao menos um profissional para adicionar.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }
    
        try {
            const payload = {
                idPrograma: parseInt(idProgramaParam),
                profissionais: selectedUsers.join(","),
            };
            await api.post(`/PmeProfissionalPME/adicionar`, payload, config);
    
            Swal.fire({
                title: "Sucesso",
                text: "Profissionais adicionados ao programa com sucesso! Atualize o programa para que ele apareça.",
                icon: "success",
                showConfirmButton: false,
                timer: 3000,
            });
    
            await getProfissionaisNaoAssociados(idProgramaParam);
            setSelectedUsers([]);
            onRequestClose();
        } catch (error) {
            console.error("Erro ao adicionar profissionais ao programa:", error);
            Swal.fire({
                title: "Erro",
                text: "Não foi possível adicionar os profissionais. Tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };    

    const style = {
        content: {
            top: '45%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '30%',
            overflowY: 'auto',
            minHeight: 'calc(0vh - 250px)',
            maxHeight: 'calc(100vh - 250px)',
        },
        overlay: {
            zIndex: 9999
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="PME - Profissionais"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalCicloAdd>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <StyledTablePmePrograma>
                        <StyledTablePage>
                            {
                                listaUsuariosData?.data?.length > 0 ?
                                (
                                    <div className="table-scroll font-0-9x table-bordered table-container">
                                        <table className="table table-width table-sm">
                                            <thead>
                                                <tr className="table-legend-info">                                                                                
                                                    <th>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                                            checked={
                                                                selectedUsers.length === listaUsuariosData.data.length &&
                                                                selectedUsers.length > 0
                                                            }
                                                        />
                                                    </th>                                                                                
                                                    <th key="nomeUsuario">Profissional</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {listaUsuariosData?.data
                                                // ?.filter(usuario => usuario.idArea) // Filtra apenas os usuários com IdArea não nulo ou vazio
                                                ?.sort((a, b) => a.nomeTSImport.localeCompare(b.nomeTSImport)) // Ordena alfabeticamente pelo campo nomeTSImport
                                                ?.map((usuario, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedUsers.includes(usuario.idUsuario)}
                                                                onChange={() => handleCheckboxUsuariosChange(usuario.idUsuario)}
                                                            />
                                                        </td>
                                                        <td className="text-left">{usuario.nomeTSImport}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : listaUsuariosData?.data && listaUsuariosData.data?.length === 0 ? (
                                    <StldColumn xs="12" sm="12" md="12">
                                        <div className="alert alert-warning" role="alert">
                                            Atenção! Nenhum resultado encontrado!
                                        </div>
                                    </StldColumn>
                                ) : (
                                    <StldColumn xs="12" sm="12" md="12">
                                        <div className="alert alert-warning" role="alert">
                                            Erro ao carregar os dados ou estrutura inesperada.
                                        </div>
                                    </StldColumn>
                                )
                            }
                            <div className='d-flex justify-content-center mt-3'>
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <button type="button" className='default-button-red-small ms-5 px-2 py-2' onClick={ addProfissionaisAoPrograma }>Adicionar ao Programa</button>
                                </div>
                            </div>
                        </StyledTablePage>
                    </StyledTablePmePrograma>
                </StyledForm>
            </StyledModalCicloAdd>
        </Modal>
    );
};